
import { Component, Vue, Prop } from "vue-property-decorator";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import VekaletList from "@/components/lists/VekaletList.vue";

@Component({
  components: { VekaletList },
})
export default class DeletePersonelDialog extends DeleteDialog {
  @Prop() action!: string;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: false }) buttonxsmall!: boolean;
  @Prop() item!: any;
  @Prop() tooltip!: string;
  /**
   * DEV-2113 — kısıtlı dönemde personel silinemez ama pasifleştirilebilir: işten ayrılan
   * çalışanın erişimi 90 gün sürmesin. Pencere açılır, yalnız "Sil" kapalı kalır.
   */
  @Prop({ default: false }) silmeKisitli!: boolean;

  show: boolean = false;
  vekaletleriGoster: boolean = false;
  state: string = "asking";
  loadingAction: string | null = null; // 'sil' | 'pasif' | null — işlem sürerken butonları kilitler

  get title(): string {
    return "Emin misiniz?";
  }

  get content(): string {
    if (this.silmeKisitli) {
      return "Lisans süresi dolduğu için kısıtlı modda personel silinemez. Personelin erişimini kesmek için pasifleştirebilirsiniz.";
    }
    if (this.vekaletler) {
      return (
          "Silmek istediğiniz personele ait vekalet bilgisi bulunmaktadır. Personeli silmek için " +
          "öncelikle bulunduğu vekaletlerden çıkarmanız gerekmektedir. Vekaletlerden çıkarmak istemiyorsanız personeli " +
          "pasifleştirebilirsiniz."
      );
    }
    return "Bu personelin erişimi kesilecek ve pasife alınacaktır. 'Pasif Kullanıcılar' bölümünden tekrar aktifleştirebilirsiniz. Devam etmek istiyor musunuz?";
  }

  get vekaletler() {
    return this.item.vekaletler && this.item.vekaletler.length > 0;
  }

  get cannotDelete(): boolean {
    return this.item.id === 1;
  }

  load() {
    this.$emit("load");
  }

  pasiflestir() {
    if (this.loadingAction) return;
    this.loadingAction = "pasif";
    this.$http.post("/api/v1/personel/" + this.item.id + "/pasiflestir").then(() => {
      this.$emit("onSuccess");
      this.load();
      this.onClose();
    }).finally(() => {
      this.loadingAction = null;
    });
  }

  onSubmit() {
    if (this.loadingAction || this.silmeKisitli) return;
    if (!this.vekaletler && !this.cannotDelete) {
      this.state = "deleting";
      this.loadingAction = "sil";
      this.$http.delete(this.action).then(() => {
        this.$emit("success");
        this.state = "asking";
        this.onClose();
      }).catch((err) => {
        console.error("İşlem başarısız oldu", err);
        this.state = "asking";
      }).finally(() => {
        this.loadingAction = null;
      });
    }
  }
}
